import React from "react";
import { Props } from "./types";

function ProjectModelsIcon({ className, style }: Props) {
  return (
    <svg viewBox="0 0 40 40.001" className={className} style={style}>
      <g transform="translate(-1736.498 -490.741)">
        <g transform="translate(1736.498 490.741)">
          <path
            d="M1774.887,490.741h-36.779a1.611,1.611,0,0,0-1.611,1.612V529.13a1.611,1.611,0,0,0,1.611,1.612h36.779a1.611,1.611,0,0,0,1.611-1.612V492.353A1.612,1.612,0,0,0,1774.887,490.741Zm-1.611,36.779h-33.558V493.964h33.558Z"
            transform="translate(-1736.498 -490.741)"
          />
        </g>
        <g transform="translate(1738.108 504.272)">
          <rect width="36.832" height="3.221" />
        </g>
        <g transform="translate(1759.8 505.883)">
          <rect width="3.221" height="23.302" />
        </g>
        <g transform="translate(1738.108 515.601)">
          <rect width="23.302" height="3.221" />
        </g>
      </g>
    </svg>
  );
}

export { ProjectModelsIcon };
